import { JSX } from 'react';
import {
    Show,
    SimpleShowLayout,
    TextField,
    EmailField,
    SelectField,
    TopToolbar,
    EditButton,
    useRecordContext,
    ShowButton,
    Datagrid,
    ReferenceManyField,
} from 'react-admin';
import {
    Grid,
    Box,
    LinearProgress
} from '@mui/material';
import { useGetCountries } from "../global-hooks/default-system-hooks";

const ShowActions: () => JSX.Element = (): JSX.Element => {

    return (
        <TopToolbar>
            <EditButton />
        </TopToolbar>
    );
}

const ShowContactTitle: () => JSX.Element = (): JSX.Element => {
    const record = useRecordContext();
    if (!record) return null;
    return <span>{ "Person - " + record.name }</span>
}

export const AdminPeopleShow: () => JSX.Element = (): JSX.Element => {
    const { loadedCountries, loading } = useGetCountries();
    return (
        <Box sx={ { flexGrow: 1, padding: '0 16px 0 16px' } }>
            <Grid container spacing={ 2 }>
                <Grid size={ 12 }>
                    <Show actions={ <ShowActions /> } title={ <ShowContactTitle /> }>
                        <Grid container spacing={ 2 }>
                            <Grid size={ 6 }>
                                <SimpleShowLayout>
                                    <TextField source="id" />
                                    <TextField source="name" />
                                    <EmailField source="email" />
                                    { (loading) &&
                                        <LinearProgress sx={ { margin: '10px 0', width: '75%' } } />
                                    }
                                    { (!loading) &&
                                        <SelectField
                                            choices={ loadedCountries }
                                            source="country"
                                            optionValue="id"
                                        />
                                    }

                                </SimpleShowLayout>
                            </Grid>
                        </Grid>
                    </Show>
                </Grid>
                <Grid size={ 12 }>
                    <Grid container spacing={ 2 }>
                        <Grid size={ 6 }>
                            <Show title=" " actions={ false } >
                                <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                                    <span>Employment</span>
                                </Box>
                                <ReferenceManyField
                                    label="Employment"
                                    source="employment"
                                    reference="employee"
                                    target="id"
                                >
                                    <Datagrid bulkActionButtons={ false }>
                                        <TextField source="companyName" sx={ { textTransform: 'capitalize' } } />
                                        <>
                                            <ShowButton />
                                            <EditButton />
                                        </>
                                    </Datagrid>
                                </ReferenceManyField>
                            </Show>
                        </Grid>
                        <Grid size={ 6 }>
                            <Show title=" " actions={ false } >
                                <Box sx={ { padding: '5px 10px 5px 10px', fontSize: '24px' } }>
                                    <span>Social Media</span>
                                </Box>
                                <ReferenceManyField
                                    label="Social"
                                    source="socials"
                                    reference="social"
                                    target="id"
                                >
                                    <Datagrid bulkActionButtons={ false }>
                                        <TextField source="platform" sx={ { textTransform: 'capitalize' } } />
                                        <>
                                            <ShowButton />
                                            <EditButton />
                                        </>
                                    </Datagrid>
                                </ReferenceManyField>
                            </Show>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}